import React, { type PropsWithChildren } from 'react';

import { Navigate } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { isToursCommandCentreEnabled } from './featureFlag';

type Props = PropsWithChildren<{
  user: Parameters<typeof isToursCommandCentreEnabled>[0];
  isLoading: boolean;
}>;

export default function ToursCommandCentreRouteGate({ user, isLoading, children }: Props) {
  // AuthContext can resolve before HomeRoute's effect copies the user into Redux.
  if (isLoading || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return isToursCommandCentreEnabled(user) ? <>{children}</> : <Navigate to="/" replace />;
}
